import React from 'react';
import './brand.css';

// Recursos gráficos del manual de marca v1.0 (p.24) usados en el sitio público.
// Importa brand.css: cualquier pieza que use la marca trae la base de estilos.

/** Viñeta de píxeles: cuadrados redondeados de menor a mayor. */
export const Px: React.FC = () => (
  <span className="lp-px" aria-hidden="true">
    <i />
    <i />
    <i />
  </span>
);

/** Mayúsculas espaciadas con viñeta de píxeles, sobre el titular. */
export const Eyebrow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="lp-eyebrow">
    <Px />
    {children}
  </span>
);

/** Surcos: arcos concéntricos al 8–20 % de opacidad, cierre de piezas. */
export const Surcos: React.FC<{
  color?: 'verde' | 'blanco';
  arcs?: 3 | 4;
  style: React.CSSProperties;
  opacity?: number;
}> = ({ color = 'verde', arcs = 4, style, opacity = 0.08 }) => (
  <svg
    className="lp-surcos"
    style={style}
    viewBox="0 0 760 420"
    fill="none"
    stroke={color === 'verde' ? '#193D2A' : '#FFFFFF'}
    strokeOpacity={opacity}
    strokeWidth={16}
    aria-hidden="true"
  >
    <path d="M20 420 A360 360 0 0 1 740 420" />
    <path d="M90 420 A290 290 0 0 1 670 420" />
    <path d="M160 420 A220 220 0 0 1 600 420" />
    {arcs === 4 && <path d="M230 420 A150 150 0 0 1 530 420" />}
  </svg>
);

export { LOGO_VERDE, LOGO_BLANCO, ISOTIPO_VERDE, ISOTIPO_BLANCO } from './brandAssets';

export const INSTAGRAM_URL = 'https://www.instagram.com/micampodigital/';

/** Ícono de Instagram (lucide no lo trae): mismo trazo de 2 px que el resto. */
export const InstagramIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <path d="M17.5 6.5h.01" />
  </svg>
);
